import ForecastingPage from "./ForecastingPage";

export default ForecastingPage;
